import { skills } from "../../data/mock";
import SectionHeading from "../SectionHeading";

const stats = [
  { value: "4+", label: "Years on .NET" },
  { value: "100+", label: "Machines, real-time" },
  { value: "26+", label: "GitHub repositories" },
  { value: "2022", label: "Shipping since" }
];

const About = () => {
  return (
    <section id="about" className="relative py-24 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading index="01" eyebrow="Profile" title="About" accent="me">
          Backend engineer building the ERP and real-time systems that keep
          factory floors running — clean architecture over quick hacks, every time.
        </SectionHeading>

        <div className="mt-16 grid lg:grid-cols-12 gap-8 items-start">
          {/* Narrative */}
          <div className="lg:col-span-7 space-y-6">
            <div className="relative bg-panel/70 backdrop-blur-sm border border-line rounded-lg p-8 panel-ticks group">
              <div className="eyebrow mb-6">
                <span className="idx">//</span> journey
              </div>

              <div className="space-y-5 text-fg-dim leading-relaxed">
                <p>
                  I'm a <strong className="text-fg font-semibold">backend-focused
                  software engineer</strong> who builds systems for the factory floor —
                  the kind that have to be correct at 3 a.m. with a line running. My
                  work sits where <strong className="text-fg font-semibold">ERP meets
                  MES</strong>: live machine data, production planning, and the
                  integration glue between them.
                </p>
                <p>
                  Today I lead backend development on a real-time MES operating across{" "}
                  <strong className="text-signal font-semibold">100+ machines</strong>,
                  processing second-by-second production data and pushing it to operator
                  dashboards over SignalR — fully synchronized with ERP.
                </p>
                <p>
                  I care about <strong className="text-fg font-semibold">architecture
                  over implementation</strong>: clean boundaries, maintainable code, and
                  systems that still make sense two years later.
                </p>
              </div>
            </div>

            {/* Stat cluster */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-line border border-line rounded-lg overflow-hidden">
              {stats.map((s) => (
                <div key={s.label} className="bg-panel px-4 py-6 text-center">
                  <div className="font-display text-3xl font-bold text-fg">{s.value}</div>
                  <div className="mt-2 font-mono text-[11px] uppercase tracking-wider text-fg-mute leading-tight">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Expertise + philosophy */}
          <div className="lg:col-span-5 space-y-6">
            <div className="bg-panel/70 backdrop-blur-sm border border-line rounded-lg p-8">
              <div className="eyebrow mb-6">
                <span className="idx">//</span> technical.stack
              </div>
              <div className="space-y-5">
                {skills.map((group) => (
                  <div key={group.category}>
                    <h4 className="font-mono text-xs uppercase tracking-wider text-fg-mute mb-2.5">
                      {group.category}
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {group.items.map((skill) => (
                        <span
                          key={skill}
                          className="px-2.5 py-1 bg-panel2 text-fg-dim rounded text-sm border border-line hover:border-signal/50 hover:text-fg transition-colors"
                        >
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative bg-panel/70 backdrop-blur-sm border border-line rounded-lg p-8 overflow-hidden">
              <div className="absolute top-0 left-0 w-1 h-full bg-signal" />
              <blockquote className="text-fg leading-relaxed text-lg">
                "I don't build hype. I build systems. Great software is about
                understanding real operational challenges and delivering sustainable
                solutions. Architecture over implementation, always."
              </blockquote>
              <div className="mt-4 font-mono text-xs uppercase tracking-wider text-signal">
                — N. Fatih Akkın
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
